import { render, staticRenderFns } from "./RightPanel.vue?vue&type=template&id=348d4ef2&scoped=true&"
import script from "./RightPanel.vue?vue&type=script&lang=js&"
export * from "./RightPanel.vue?vue&type=script&lang=js&"
import style0 from "./RightPanel.vue?vue&type=style&index=0&id=348d4ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d4ef2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348d4ef2')) {
      api.createRecord('348d4ef2', component.options)
    } else {
      api.reload('348d4ef2', component.options)
    }
    module.hot.accept("./RightPanel.vue?vue&type=template&id=348d4ef2&scoped=true&", function () {
      api.rerender('348d4ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/RightPanel.vue"
export default component.exports